<template>
    <div class="card">
        <div v-if="type === 'job'" class="header-section">
            <div class="status-text text-right">
                <div v-if="status === 'In Review'">
                    <span class="pulse-review">
                    </span>
                    <span class="application-status-review">{{status}}</span>
                </div>

                <div v-if="status === 'Approved'">
                    <span class="pulse-review">
                    </span>
                    <span class="application-status-approved">{{status}}</span>
                </div>

                <div v-if="status === 'Challenge Submitted'">
                    <span class="pulse-review">
                    </span>
                    <span class="application-status-challengesubmitted">  
                        {{status}}
                    </span>
                    
                </div>

                <div v-if="status === 'Shortlisted'">
                    <span class="pulse-shortlisted">
                    </span>
                    <span class="application-status-shortlisted">{{status}}</span>
                </div>

            </div>
            <center>
            <div class="icon">
                <img :src="iconURL" class="card-icon" />
            </div>
            </center>
        </div>
        <div v-else class="header-section">
            <img :src="headerImg" class="card-img" />
        </div>
        <div class="bottom-panel">
            <div class="card-title">
                {{title}}
            </div>
            <div class="date-created">
                {{dateCreated}}
            </div>
        </div>
    </div>
    
</template>


<script>
export default {
    name: 'ContentCard',
    props: {
        title: String,
        dateCreated: String,
        status: String,
        iconURL: String,
        type: String,
        headerImg: String
    }
}
</script>


<style scoped>

.card {
    margin-top:20px; 
    margin-bottom:20px; 
    width:100%;
    border:none;
    box-shadow: 4px 2px 4px 0px rgba(46,61,73,0.15);
    transition: all 0.3s ease;
    font-family: Helvetica;
    cursor:pointer;
    background-color:#fff;
    color:#333;
    display:inline-block;
}

.header-section {
    height: 160px;
}

.card-icon {
    width:140px;
    height:70px;
    margin-top:10px;
}

.card-img {
    width:100%;
    height:100%;
}

.bottom-panel {
    margin-top:15%;
    margin-bottom:7%;
    margin-left:8%;
    margin-right:8%;
}

.status-text {
    padding-top:10px;
    padding-bottom:20px;
    margin-right:15px;
}

.date-created {
    color: #888;
    font-size: 0.85rem;
}

.application-status-review {
    color: #6c63ff;
    font-size: 0.85rem;
}

.application-status-approved {
    color: #6c63ff;
    font-size: 0.85rem;
}

.application-status-challengesubmitted {
    color: #6c63ff;
    font-size: 0.85rem;
}

.application-status-shortlisted {
    color: green;
    font-size: 0.85rem;
}

.pulse-review {
    display: inline-block;
    margin-left:8px;
    margin-right:8px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #6c63ff;
    cursor: pointer;
    box-shadow: 0 0 0 rgba(204,169,44, 0.4);
    
}

.pulse-shortlisted {
    display: inline-block;
    margin-left:8px;
    margin-right:8px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: green;
    cursor: pointer;
    box-shadow: 0 0 0 rgba(204,169,44, 0.4);
    
}

</style>
